import React, { FC } from 'react'
import { Grid, CleanButton, breakpoints, theme } from '@components/gassan-ui'
import { rem } from 'polished'
import styled from 'styled-components'

const Button = styled(CleanButton)`
  height: 2rem;
  width: 2rem;
  border-radius: 100%;
  background: black;
  color: white;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  @media screen and (min-width: ${breakpoints.large}) {
    width: 2.5rem;
    height: 2.5rem;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${theme.rolex.colors.primary};
    }
  }
`

type Props = {
  onZoomIn: () => void
  onZoomOut: () => void
}

const ZoomButtons: FC<Props> = ({ onZoomIn, onZoomOut }) => {
  return (
    <Grid
      position="absolute"
      right={rem(25)}
      top={rem(25)}
      zIndex={2}
      gridAutoFlow="row"
      gridRowGap="0.5rem"
    >
      <Button onClick={onZoomIn}>
        <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
          <path d="m11 6.15h-4.85v4.85h-1.3v-4.85h-4.85v-1.3h4.85v-4.85h1.3v4.85h4.85z" />
        </svg>
      </Button>
      <Button onClick={onZoomOut}>
        <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
          <path d="m0 6.5v-1h11v1z" />
        </svg>
      </Button>
    </Grid>
  )
}

export default ZoomButtons
